export function createHttpWithAuth() {
    return {
        fetch(url: RequestInfo, init?: RequestInit): Promise<Response> {
            return fetch(url, {
                ...init,
                credentials: 'include',
            });
        },
    };
}
